import React, { createRef, useEffect } from 'react'
import { withUIContext, withUserContext } from 'context'
import { ButtonSimple, Text, Popup, Icon } from 'components/common'
import { Form, Input } from 'antd'

const AddProConPopup = ({ toggleConProPopup, enableDomScroll, proConPopupIsOpen, proConPopupBtnColor, ...props }) => {

	const inputRef = createRef()

	const add = () => {
		let data = {
			type: props.proConType,
			text: inputRef.current.resizableTextArea.textArea.value,
			debate_id: props.debateId
		}

		if (props.feedbackId) {
			data.parent_id = props.feedbackId;
		}

		if (data.text.length > 0) {
			return props.addFeedback(data).then(() => {
				toggleConProPopup()
			})
		}
	}

	useEffect(() => {
		if (proConPopupIsOpen) {
			inputRef.current.focus()
		}
	}, [proConPopupIsOpen])

	return (
		<Popup
			functionClose={() => {
				toggleConProPopup()
				enableDomScroll()
			}}
			className={`${props.className}`}
			popupIsOpen={proConPopupIsOpen}
		>
			<div className='add-pro-con-popup flexBoxColumn'>
				<Icon onClick={() => toggleConProPopup('')} className='op-close' />
				<Text tag='p' className='PopSemi h11' text='New Argument' />
				<Text tag='h5' className='text PopReg h5' text='Your statement' />
				<Form.Item>
					<Input.TextArea
						ref={inputRef}
						rows={6}
						className="input-text"
						placeholder={'Add argument'}
						showCount
						maxLength="800"
					/>
				</Form.Item>

				<div className='buttons flexBox justifyEnd'>
					<ButtonSimple onClick={add} className={proConPopupBtnColor} text='Add argument' />
				</div>
			</div>
		</Popup>
	)
}

export default withUIContext(withUserContext(AddProConPopup, ['addFeedback']), ['toggleConProPopup', 'enableDomScroll', 'proConPopupIsOpen', 'proConPopupBtnColor', 'proConType'])
